import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import './styles.scss';

const DraggableList = ({ list, renderItem, onDragFinish }) => {
  const containerHeightRef = createRef();

  return (
    <div ref={containerHeightRef}>
      <DragDropContext onDragEnd={onDragFinish} id={'DraggableListId'}>
        <Droppable droppableId={'DraggableList'}>
          {(provided, snapshot) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {list.map((option, index) => (
                <div key={`DraggableItemContainer-${index}`}>
                  <Draggable draggableId={`DraggableList-${index}`} index={index}>
                    {(provided, snapshot) => (
                      <div
                        className={'Draggable__Item'}
                        id={`DraggableItemId-${index}`}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}>
                        {renderItem(option, index)}
                      </div>
                    )}
                  </Draggable>
                </div>
              ))}
              { provided.placeholder }
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

DraggableList.propTypes = {
  list: PropTypes.array.isRequired,
  onDragFinish: PropTypes.func.isRequired,
  renderItem: PropTypes.func.isRequired
};

export default DraggableList;
